import styles from "./Header.module.scss";
import { StatsPanel } from "../StatsPanel/StatsPanel";

export const Header = () => (
    <div className={styles.header}>
        <StatsPanel />
    </div>
);

